module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-c0ed5467b8603e27b16ea187c237c313.png";